import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems, RowDeselectEventArgs, RowSelectEventArgs, ContextMenuItemModel } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { isNumber } from 'highcharts';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { EstadoService, MedioPagoService, MonedaService, MovimientoService, TipoMovimientoService, MenuFuncionService, TenantService, ConsorcioService, ComunidadService, UnidadFuncionalService, ProveedorService } from '../../../../src/app/shared/services';
import { GridPageSettings, MedioPago, MenuFuncionCodes, Moneda, Movimiento, SearchEstadoRequest, SearchMedioPagoRequest, SearchMonedaRequest, Estado, TenantFeatureFlags, LocalStorageKeys, SearchUnidadFuncionalRequest, UnidadFuncional, SearchConsorcioRequest, SearchComunidadRequest, Consorcio, Comunidad, SearchProveedorRequest, Proveedor, TenantEnum,
  SearchMovimientoRequest, SearchTipoMovimientoRequest, TipoMovimiento, EstadoConstants, DialogConfirmRequest, DialogConfirmResponse, SearchMovimientoItemDto
 } from '../../../../src/app/shared/model';

import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';

import { MenuEventArgs } from '@syncfusion/ej2-angular-navigations';
import { ExportMediaTypeConstants } from '../../shared/model';

@Component({
  selector: 'app-movimientoLista',
  templateUrl: './movimientoLista.component.html',
  styles: []
})

export class MovimientoListComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  public format = { type:'date', format:'dd/MM/yyyy HH:mm' }
  total: number = 0;
  searchForm: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isCancelling: boolean = false;
  isTipoSearching: boolean = false;
  isEstadoSearching: boolean = false;
  isMonedaSearching: boolean = false;
  isMedioPagoSearching: boolean = false;
  isStatisticsSearching: boolean = false;
  isRejecting: boolean = false;
  isUnidadesFuncionalesSearching: boolean = false;
  isConsorcioSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isProveedorAutoSearching: boolean = false;

  multiSelectionEnabled: boolean = false;
  isRosbaco: boolean = false;
  TenantEnum = TenantEnum;
  mouseClick: number;

  canAdd: boolean = false;
  canView: boolean = false;
  canFinanciar: boolean = false;
  canCancelar: boolean = false;
  canAddDeuda: boolean = false;
  canAddPago: boolean = false;
  canViewDetail: boolean = false;
  canAnalizarDocs: boolean = false;
  canRecurrentes: boolean = false;

  verSoloActivos: boolean = true;

  tipoMovimientoList: TipoMovimiento[];
  monedaList: Moneda[];
  estadoList: Estado[];
  medioPagoList: MedioPago[];
  categoriaList: any[];
  consorcioList: Consorcio[];
  comunidadList: Comunidad[];
  ufList: UnidadFuncional[];
  filteredProveedorList: Proveedor[] = [];

  tenantFeatureFlags: TenantFeatureFlags;

  public query: Query;
  public totales: any[];
  public totalesSaldos: any[];
  public totalesSeleccionados: any[] = [];

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  public contextMenuItems: ContextMenuItemModel[];

  private readonly gridColumns = [
    { field: 'FechaMovimiento', headerText: 'Fecha', width: 90, type: 'date' },
    { field: 'FechaVencimiento', headerText: 'Vencimiento', width: 90, type: 'date' },
    { field: 'CuentaImputada', headerText: 'Referencia', width: 90 },
    { field: 'CuentaImputadaCodigo', headerText: 'Cuenta', width: 90 },
    { field: 'TipoMovimientoNombre', headerText: 'Tipo', width: 80 },
    { field: 'Detalle', headerText: 'Detalle', width: 100 },
    { field: 'Estado', headerText: 'Estado', width: 80 },
    { field: 'AlicuotaIvaNombre', headerText: 'IVA', width: 70, textAlign: 'right' },
    { field: 'Monto', headerText: 'Monto', width: 70, textAlign: 'right' },
    { field: 'Saldo', headerText: 'Saldo', width: 70, textAlign: 'right' }
  ];

  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private menuService: MenuFuncionService,
    private service: MovimientoService,
    private tipoMovimientoService: TipoMovimientoService,
    private monedaService: MonedaService,
    private estadoService: EstadoService,
    private tenantService: TenantService,
    private medioPagoService: MedioPagoService,
    private consorcioService: ConsorcioService,
    private comunidadService: ComunidadService,
    private unidadFuncionalService: UnidadFuncionalService,
    private proveedorService: ProveedorService,
    private datePipe: DatePipe
  ) {
    this.isRosbaco = this.sharedFunctions.isRosbacoUser();
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.MOVIMIENTO).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result) {

        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canAdd = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_PAGO || x == MenuFuncionCodes.MOVIMIENTO_DEUDA);
            this.canAddDeuda = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_DEUDA);
            this.canAddPago = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_PAGO);
            this.canView = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_LIST);
            this.canFinanciar = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_FINANCIACION);
            this.canCancelar = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_CANCELACION);
            this.canAnalizarDocs = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_ANALISIS_DOCUMENTO_MASIVO);
            this.canRecurrentes = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_RECURRENTES);

            if (this.canView) {
              this.loadView();
            }
            else {
              this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
              this.router.navigate(['/']);
            }
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });

    this.contextMenuItems = this.sharedFunctions.initializeContextMenu(this.gridColumns);
  }

  loadView() {
    this.canView = true;

    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    this.buildForm();

    this.getTiposMovimiento();
    this.getEstados();
    this.getCategorias();
    this.getMonedas();
    this.getMediosPago();
    this.getConsorcios();
    this.getComunidades();
    this.getProveedoresAutocomplete();

    this.setQueryParams();

    setTimeout(() => {
      this.sharedFunctions.setColumnsVisibility("FechaVencimiento", this.grid, this.gridColumns);
      this.sharedFunctions.setColumnsVisibility("CuentaImputadaCodigo", this.grid, this.gridColumns);
      this.sharedFunctions.setColumnsVisibility("TipoMovimientoNombre", this.grid, this.gridColumns);
      this.sharedFunctions.setColumnsVisibility("Estado", this.grid, this.gridColumns);
      this.sharedFunctions.setColumnsVisibility("AlicuotaIvaNombre", this.grid, this.gridColumns);

      this.data = new DataManager({
        url: this.service.getSearchUrl(),
        adaptor: new WebApiAdaptor(),
        headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
      });
    }, 500);

    this.getSearchEstadisticas();
  }

  buildForm() {
    var fechaHoy = new Date();

    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    this.searchForm = this.formBuilder.group({
      'FechaMovimientoDesde': [null],
      'FechaMovimientoHasta': [fechaHoy],
      'FechaVencimientoDesde': [null],
      'FechaVencimientoHasta': [null],

      'NroDocumento': [null],
      'MailContacto': [null],
      'MovilContacto': [null],
      'Usuario': [null],
      'ComunidadId': [null],
      'ConsorcioId': [cId],
      'UnidadFuncionalId': [null],
      'Proveedor': [null],

      'PedidoId': [null],
      'Contrato': [null],

      'Detalle': [null],
      'TipoMovimientoId': [null],
      'MonedaId': [null],
      'Estados': [null],
      'MedioPagoId': [null],
      'Signo': [null],
      'VerSoloDeudasPendientes': [null],
      'VerSoloActivos': [true],

      'gridPage': [1],
      'OrderAscending': [true],
      'OrderFieldName': [null]
    });

    var filtros = this.sharedFunctions.getReporteFiltros("app-movimientoLista");

    if (filtros != null) {
      this.searchForm.patchValue(filtros);
      if (filtros.gridPage != null && filtros.gridPage > 0)
        this.pageSettings.currentPage = filtros.gridPage;
    }
  }

  isProcessing() {
    return (this.isCancelling || this.isSearching || this.isExporting);
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
        if (this.searchForm.get(formFieldName) != null && this.searchForm.get(formFieldName)?.value)
            this.searchForm.get(formFieldName)?.setValue(null);
    }
  }

  getProveedoresAutocomplete() {
    this.searchForm.get('Proveedor')?.valueChanges
      .pipe(
        filter(res => {
          return res && res !== null && res.length >= 3
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {
          this.filteredProveedorList = [];
          this.isProveedorAutoSearching = true;
        }),
        switchMap(value => this.proveedorService.search(new SearchProveedorRequest(null, null, true, "RazonSocial", null, !isNumber(parseInt(value)) ? value : null, isNumber(parseInt(value)) ? value : null, null, null, null, true))
          .pipe(
            finalize(() => {
              this.isProveedorAutoSearching = false;
            }),
          )
        )
      )
      .subscribe((data: any) => {
        if (data != null && data.result != null)
          this.filteredProveedorList = data.result;
        else
          this.filteredProveedorList = [];
        // (this.filteredProveedorList, 'lista proveedor')
      });
  }

  displayProveedor(proveedor: Proveedor): string {
    return proveedor && proveedor?.RazonSocial ? proveedor.RazonSocial : '';
  }

  getTiposMovimiento() {
    this.isTipoSearching = true;
    let searchAllTiposMovimiento = new SearchTipoMovimientoRequest(null, null, true, "Nombre", null, null, null, null, true);

    this.tipoMovimientoService.search(searchAllTiposMovimiento).subscribe(data => {
      this.isTipoSearching = false;
      if (data != null)
        this.tipoMovimientoList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getCategorias() {
    this.categoriaList = [
      { Id: -1, Nombre: "Ver solo deudas" },
      { Id: 1, Nombre: "Ver solo pagos" }
    ];
  }

  getConsorcios() {
    if (!this.tenantFeatureFlags?.HabilitarGestionConsorcio)
      return;

    var r = new SearchConsorcioRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isConsorcioSearching = true;

    this.consorcioService.search(r).subscribe(data => {
      this.isConsorcioSearching = false;
      this.consorcioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isConsorcioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getComunidades() {
    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMonedas() {
    this.isMonedaSearching = true;
    let searchAllMonedas = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.monedaService.search(searchAllMonedas).subscribe(data => {
      this.isMonedaSearching = false;
      if (data != null)
        this.monedaList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isMonedaSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getEstados() {
    let searchAllEstado = new SearchEstadoRequest(null, null, true, "Nombre", null, null, true);
    this.isEstadoSearching = true;

    this.estadoService.searchMovimientoEstados(searchAllEstado).subscribe(data => {
      this.isEstadoSearching = false;
      if (data != null)
        this.estadoList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isEstadoSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getMediosPago() {
    this.isMedioPagoSearching = true;
    let searchAllMedioPago = new SearchMedioPagoRequest(null, null, true, "Nombre", null, null, true);

    this.medioPagoService.search(searchAllMedioPago).subscribe(data => {
      this.isMedioPagoSearching = false;
      if (data != null)
        this.medioPagoList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isMedioPagoSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  compareEstados(o1: number, o2: number): boolean {
    return o1 == o2;
  }

  onSearch() {
    this.multiSelectionEnabled = false;
    this.isSearching = true;

    this.searchForm.get('gridPage')?.setValue(1);
    this.searchForm.get('OrderAscending')?.setValue(true);
    this.searchForm.get('OrderFieldName')?.setValue(null);
    this.sharedFunctions.setReporteFiltros("app-movimientoLista", this.searchForm.getRawValue());

    this.setQueryParams();

    this.getSearchEstadisticas();
    this.grid.refresh();

    this.totalesSeleccionados = [];
    this.isSearching = false;
  }

  getSearchEstadisticas() {
    var search = new SearchMovimientoRequest(null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,
      null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
    search = {
      ...search,
      ...this.searchForm.value,
      ... {
        ProveedorId: this.searchForm.get("Proveedor")?.value?.Id
      }
    };

    this.isStatisticsSearching = true;
    this.service.getSearchEstadisticas(search).subscribe(data => {
      this.isStatisticsSearching = false;
      if (data.Success) {
        this.totales = data.Result.Totales;
        this.totalesSaldos = data.Result.TotalesSaldos;
      }
    },
    (err: HttpErrorResponse) => {
      this.isStatisticsSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "MedioPagoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MedioPagoId;
    else
      this.query.addParams("MedioPagoId",this.searchForm.value.MedioPagoId);

    index = this.query.params.findIndex(obj => obj.key === "FechaMovimientoDesde");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaMovimientoDesde, "yyyy-MM-dd");
    else
      this.query.addParams("FechaMovimientoDesde", this.datePipe.transform(this.searchForm.value.FechaMovimientoDesde, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaMovimientoHasta");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaMovimientoHasta, "yyyy-MM-dd");
    else
      this.query.addParams("FechaMovimientoHasta", this.datePipe.transform(this.searchForm.value.FechaMovimientoHasta, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaVencimientoDesde");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaVencimientoDesde, "yyyy-MM-dd");
    else
      this.query.addParams("FechaVencimientoDesde", this.datePipe.transform(this.searchForm.value.FechaVencimientoDesde, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaVencimientoHasta");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaVencimientoHasta, "yyyy-MM-dd");
    else
      this.query.addParams("FechaVencimientoHasta", this.datePipe.transform(this.searchForm.value.FechaVencimientoHasta, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "Estados");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Estados?.join(",");
    else
      this.query.addParams("Estados", this.searchForm.value.Estados?.join(","));

    index = this.query.params.findIndex(obj => obj.key === "PedidoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.PedidoId;
    else
      this.query.addParams("PedidoId",this.searchForm.value.PedidoId);

    index = this.query.params.findIndex(obj => obj.key === "Contrato");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Contrato;
    else
      this.query.addParams("Contrato",this.searchForm.value.Contrato);

    index = this.query.params.findIndex(obj => obj.key === "MonedaId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MonedaId;
    else
      this.query.addParams("MonedaId",this.searchForm.value.MonedaId);

    index = this.query.params.findIndex(obj => obj.key === "Detalle");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Detalle;
    else
      this.query.addParams("Detalle",this.searchForm.value.Detalle);

    index = this.query.params.findIndex(obj => obj.key === "TipoMovimientoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.TipoMovimientoId;
    else
      this.query.addParams("TipoMovimientoId",this.searchForm.value.TipoMovimientoId);

    index = this.query.params.findIndex(obj => obj.key === "ProveedorId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Proveedor?.Id;
    else
      this.query.addParams("ProveedorId",this.searchForm.value.Proveedor?.Id);

    index = this.query.params.findIndex(obj => obj.key === "ConsorcioId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ConsorcioId;
    else
      this.query.addParams("ConsorcioId",this.searchForm.value.ConsorcioId);

    index = this.query.params.findIndex(obj => obj.key === "ComunidadId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ComunidadId;
    else
      this.query.addParams("ComunidadId",this.searchForm.value.ComunidadId);

    index = this.query.params.findIndex(obj => obj.key === "UnidadFuncionalId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.UnidadFuncionalId;
    else
      this.query.addParams("UnidadFuncionalId",this.searchForm.value.UnidadFuncionalId);

    index = this.query.params.findIndex(obj => obj.key === "Usuario");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Usuario;
    else
      this.query.addParams("Usuario",this.searchForm.value.Usuario);

    index = this.query.params.findIndex(obj => obj.key === "NroDocumento");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.NroDocumento;
    else
      this.query.addParams("NroDocumento",this.searchForm.value.NroDocumento);

    index = this.query.params.findIndex(obj => obj.key === "MailContacto");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MailContacto;
    else
      this.query.addParams("MailContacto",this.searchForm.value.MailContacto);

    index = this.query.params.findIndex(obj => obj.key === "MovilContacto");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MovilContacto;
    else
      this.query.addParams("MovilContacto",this.searchForm.value.MovilContacto);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloDeudasPendientes");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerSoloDeudasPendientes;
    else
      this.query.addParams("VerSoloDeudasPendientes",this.searchForm.value.VerSoloDeudasPendientes);

    index = this.query.params.findIndex(obj => obj.key === "Signo");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Signo;
    else
      this.query.addParams("Signo",this.searchForm.value.Signo);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerSoloActivos;
    else
      this.query.addParams("VerSoloActivos", this.searchForm.value.VerSoloActivos);

    index = this.query.params.findIndex(obj => obj.key === "OrderAscending");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.OrderAscending;
    else
      this.query.addParams("OrderAscending", this.searchForm.value.OrderAscending);

    index = this.query.params.findIndex(obj => obj.key === "OrderFieldName");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.OrderFieldName;
    else
      this.query.addParams("OrderFieldName", this.searchForm.value.OrderFieldName);
  }

//#region grid

  onActionBegin(args: any) {
    if (!this.isSearching) {
      if (args.requestType === 'paging') {
        this.searchForm.get('gridPage')?.setValue(args.currentPage);
        this.sharedFunctions.setReporteFiltros("app-movimientoLista", this.searchForm.getRawValue());
      }

      if (args.requestType === 'sorting') {
        this.searchForm.get('OrderAscending')?.setValue(args.direction=="Ascending");
        this.searchForm.get('OrderFieldName')?.setValue(args.columnName);
        this.sharedFunctions.setReporteFiltros("app-movimientoLista", this.searchForm.getRawValue());
      }
    }
  }

  public onRowSelect(args: RowSelectEventArgs): void {
      //this.calcularTotalSeleccionado();
      args.cancel = true;
  }

  onRowDeselected(args: RowDeselectEventArgs): void {
    this.calcularTotalSeleccionado();
  }

  //Detecta que botón del mouse se presionó sobre una row
  //event.button = 0 --> Click.Derecho
  //event.button = 2 --> Click.Izquierdo
  onClickRow(event:MouseEvent){
    this.mouseClick = event.button;

  }

  //Si se presionó el botón Derecho del mouse, la row no cambia de estado en su checkbox
  //Soluciona selección de checkbox cuando se quiere abrir menuContext
  rowSelecting(args){
    if(this.mouseClick == 2){
      args.cancel = true;     //cancel the selection during opening context menu by right click
    }
  }

//#endregion

  onDeudaFiltroUfComunidadSelect() {
    if (!this.tenantFeatureFlags?.HabilitarGestionUf)
      return;

    this.searchForm?.get("UnidadFuncionalId")?.setValue(null);

    var cId = this.searchForm?.get("ComunidadId")?.value;
    if (cId == null || cId <= 0) {
      this.ufList = [];
      return false;
    }

    var r = new SearchUnidadFuncionalRequest(null, null, true, "Codigo", null, null, null, null, null, null, cId, null, true);
    this.isUnidadesFuncionalesSearching = true;

    this.unidadFuncionalService.search(r).subscribe(data => {
      this.isUnidadesFuncionalesSearching = false;
      this.ufList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isUnidadesFuncionalesSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  add() {
    if (this.canAdd) {
      this.router.navigate(['movimiento-edit', 0]);
    }
    else {
      this.sharedFunctions.showMessage("No tiene permisos para crear un nuevo movimiento", "Error");
    }
  }

  edit(item: Movimiento) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.router.navigate(['movimiento-view', item.Id]);
  }

  financiar() {
    if (this.canFinanciar) {
      this.router.navigate(['movimiento-financiacion']);
    }
    else {
      this.sharedFunctions.showMessage("No tiene permisos para financiar deudas", "Error");
    }
  }

  onExport() {
    var search = new SearchMovimientoRequest(null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,
      null, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
    search = {
      ...search,
      ...this.searchForm.value,
      ...{
        ProveedorId: this.searchForm.get("Proveedor")?.value?.Id
      }
    };

    this.isExporting = true;
    this.service.exportSearch(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "Movimientos_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  getEstadoBackgroundColor(item: SearchMovimientoItemDto) {
    return (item != null && item.EstadoId == EstadoConstants.ESTADO_MOVIMIENTO_CANCELADO ? 'indianred' : 'black');
  }

  onReject(item: SearchMovimientoItemDto) {
    if (item == null || item.Id == null || item.Id <= 0 || !item.PuedeRechazar)
        return false;

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(
        null,
        "¿Está seguro que desea cancelar el movimiento?<br/><br/>" +
          "<b>Una vez cancelado, el movimiento no podrá volver a ser restaurado.</b>",
        "Sí, cancelar de todas formas",
        "No"
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.isRejecting = true;
        this.service.cancelar(item.Id).subscribe(data => {
          this.isRejecting = false;
          if (data != null && data.Success && data.Result) {
            this.sharedFunctions.showMessage("Se canceló correctamente el movimiento!", "Operación Exitosa!");
            this.onSearch();
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isRejecting = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    });
  }

  cancelacionMasiva() {
    var selectedRows = this.grid.getSelectedRecords() as SearchMovimientoItemDto[];
    if (selectedRows == null || selectedRows.length == 0) {
      this.sharedFunctions.showMessage("Debe seleccionar al menos un movimiento para la cancelación masiva", "Error");
      return false;
    }

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(
        null,
        "¿Está seguro que desea cancelar " + selectedRows.length + " movimientos seleccionados del listado?<br/><br/>" +
          "<b>Una vez cancelado, el movimiento no podrá volver a ser restaurado.</b>",
        "Sí, cancelar todos",
        "No"
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.isCancelling = true;
        this.service.cancelacionMasiva(selectedRows.map(s => s.Id)).subscribe(data => {
          this.isCancelling = false;
          if (data != null && data.Success && data.Result != null) {
            var msg = "Se cancelaron " + data.Result.TotalOk + " movimientos éxitosamente!";
            if (data.Result.Errores != null && data.Result.Errores.length > 0) {
              msg += "<br/><br/>Pero algunos movimientos no pudieron ser cancelados. A continuación, se deja el detalle de errores:<br/>- " +
                      data.Result.Errores.join("<br/>- ")

              const dialogRef2 = this.dialog.open(DialogConfirmComponent, {
                data: new DialogConfirmRequest(
                  "Resultado de Cancelación de Movimientos",
                  msg,
                  "Aceptar",
                  null,
                  true,
                  false
                )
              });
            }
            else
              this.sharedFunctions.showMessage(msg, "Operación Exitosa!");

            this.onSearch();
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isCancelling = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else
        this.multiSelectionEnabled = false;
    });
  }

  pagosMasivos() {
    if (this.canAddPago) {
      this.router.navigate(['movimientos-pago-masivos']);
    }
    else {
      this.sharedFunctions.showMessage("No tiene permisos para financiar deudas", "Error");
    }
  }

  calcularTotalSeleccionado() {
    this.totalesSeleccionados = [];
    var multiSelection = this.grid.getSelectedRecords();

    if (multiSelection != null && multiSelection.length > 0) {
      for (var i=0; i<multiSelection.length; i++) {
        var item = (multiSelection[i] as any);
        var index = this.totalesSeleccionados.findIndex(v => v.key == item.Moneda);

        if (index == null || index < 0) {
          this.totalesSeleccionados.push({ key: item.Moneda, value: 0 });
          index = this.totalesSeleccionados.length - 1;
        }

        this.totalesSeleccionados[index].value += parseFloat(item.Monto);
      }
    }
  }

  goToMovimientosRecurrentes() {
    if (this.canAddDeuda && this.canRecurrentes) {
      this.router.navigate(['movimientos-recurrentes']);
    }
    else {
      this.sharedFunctions.showMessage("No tiene permisos para realizar la operación", "Error");
    }
  }

  goToMovimientosDesdeDocumentos() {
    if (this.canAnalizarDocs && this.canAdd) {
      this.router.navigate(['movimientos-desde-documentos']);
    }
    else {
      this.sharedFunctions.showMessage("No tiene permisos para realizar la operación", "Error");
    }
  }

  contextMenuOpen(args: any): void {
    args.event.stopPropagation();
    args.cancel = this.sharedFunctions.updateMenuItemState(args.items,args.event.target, this.grid, this.gridColumns);
  }

  contextMenuClick(args: MenuEventArgs): void {
    args.event?.stopPropagation();
    if (!args.item.id) return;
    const { id } = args.item;
    this.sharedFunctions.setColumnsVisibility(id, this.grid, this.gridColumns);
  }
}
